import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../store/store';
import { markChannelAsRead } from '../../api/chat';
import { Channel, MessageList, MessageInput } from 'stream-chat-react';
import './ChatWindow.scss';

interface ChatWindowProps {
  channel: any;
}

const ChatWindow: React.FC<ChatWindowProps> = ({ channel }) => {
  const admin = useSelector((state: RootState) => state.admin.admin);
  const navigate = useNavigate();

  useEffect(() => {
    if (channel?._streamChannel && typeof channel._streamChannel.watch === 'function') {
      const markAsRead = async () => {
        try {
          if (!channel._streamChannel.initialized) {
            await channel._streamChannel.watch();
          }
          await markChannelAsRead(channel.id, admin.user_id);
        } catch (error) {
          console.error('Error marking channel as read in ChatWindow:', error);
        }
      };
      markAsRead();
    } else if (channel?._streamChannel) {
      const markAsRead = async () => {
        try {
          await markChannelAsRead(channel.id, admin.user_id);
        } catch (error) {
          console.error('Error marking channel as read in ChatWindow:', error);
        }
      };
      markAsRead();
    }
  }, [channel, admin.user_id]);

  const handleViewProfile = () => {
    const memberIdToUse = channel?.memberUniqueId || channel?.memberId;
    if (memberIdToUse && memberIdToUse !== admin.user_id) {
      navigate(`/members/${memberIdToUse}`);
    }
  };

  if (!channel?._streamChannel) {
    return (
      <div className="chat-window-empty">
        <p>Loading conversation...</p>
      </div>
    );
  }

  const showProfileButton = channel?.memberUniqueId && channel?.memberId !== admin.user_id;

  return (
    <Channel channel={channel._streamChannel}>
      <div className="chat-window-modern">
        <div className="chat-window-header">
          <div className="custom-header">
            <div className="header-left">
              <div className="header-avatar">
                {(channel.memberName?.[0] || 'M').toUpperCase()}
              </div>
              <div className="header-meta">
                <h1 className="header-title">{channel.memberName || 'Member'}</h1>
                <div className="header-subtitle">with {channel.name}</div>
              </div>
            </div>
            {showProfileButton && (
              <button 
                className="view-profile-button"
                onClick={handleViewProfile}
                title="Go to Member Profile"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Go to Member Profile
              </button>
            )}
          </div>
        </div>
        <div className="chat-messages-area">
          <MessageList />
        </div>
        <div className="chat-input-area">
          <MessageInput />
        </div>
      </div>
    </Channel>
  );
};

export default ChatWindow;

